import { render, staticRenderFns } from "./question_bank.vue?vue&type=template&id=7f7ed680&scoped=true"
import script from "./question_bank.vue?vue&type=script&lang=js"
export * from "./question_bank.vue?vue&type=script&lang=js"
import style0 from "./question_bank.vue?vue&type=style&index=0&id=7f7ed680&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7ed680",
  null
  
)

export default component.exports